<template>
  <div class="card">
    <button
      v-if="index != 0"
      class="btn btn__close"
      @click="$parent.removeObject(index)"
    >
      <i class="fas fa-times"></i>
    </button>
    <div class="row-2">
      <div
        class="form-group"
        :class="{ 'form-error': !object.type.required && object.$error }"
      >
        <label for="objectType">Soort object</label>
        <select v-model="object.type.$model" name="objectType">
          <option selected disabled value="">Selecteer een optie</option>
          <option value="Meubel">Meubel</option>
          <option value="Witgoed">Witgoed</option>
          <option value="Motoren/Bromfiets">Motoren/Bromfiets</option>
          <option value="Piano/Orgel">Piano/Orgel</option>
          <option value="Ophalen/Stort">Ophalen/Stort</option>
        </select>
      </div>

      <div
        class="form-group"
        :class="{
          'form-error': !object.omschrijving.required && object.$error
        }"
      >
        <label for="lengte">Omschrijving</label>
        <input
          v-model="object.omschrijving.$model"
          type="text"
          name="omschrijving"
        />
      </div>

      <!-- <button class="btn btn__filled btn__photo" type="file" name="filename">Foto toevoegen</button> -->
    </div>

    <div class="row-3">
      <div
        class="form-group"
        :class="{ 'form-error': !object.lengte.required && object.$error }"
      >
        <label for="lengte">Lengte in cm</label>
        <input v-model="object.lengte.$model" type="number" name="lengte" />
      </div>
      <div
        class="form-group"
        :class="{ 'form-error': !object.breedte.required && object.$error }"
      >
        <label for="breedte">Breedte in cm</label>
        <input v-model="object.breedte.$model" type="number" name="breedte" />
      </div>
      <div
        class="form-group"
        :class="{ 'form-error': !object.hoogte.required && object.$error }"
      >
        <label for="hoogte">Diepte in cm</label>
        <input v-model="object.hoogte.$model" type="number" name="hoogte" />
      </div>
    </div>

    <div class="row-3">
      <div
        class="form-group"
        :class="{ 'form-error': !object.gewicht.required && object.$error }"
      >
        <label for="gewicht"
          >Totaal gewicht in kg
          <vue-custom-tooltip
            position="is-right"
            label="Vul hier de totaal gewicht
van alle zelfde voorwerpen. "
          >
            <i class="fas fa-info-circle tooltip_fas"></i>
          </vue-custom-tooltip>
        </label>
        <select v-model="object.gewicht.$model" name="gewicht">
          <option value="0-34kg">0-34kg</option>
          <option value="35-79kg">35-79kg</option>
          <option value="80-200kg">80-200kg</option>
          <option value="groterdan200kg">>200kg</option>
        </select>
      </div>
      <div
        class="form-group"
        :class="{ 'form-error': !object.aantal.required && object.$error }"
      >
        <label for="aantal"
          >Aantal zelfde voorwerpen
          <vue-custom-tooltip
            position="is-right"
            label="Bijvoorbeeld:
een hoekbank bestaat uit 2 of 3 voorwerpen."
          >
            <i class="fas fa-info-circle tooltip_fas"></i>
          </vue-custom-tooltip>
        </label>
        <input v-model="object.aantal.$model" type="number" name="aantal" />
      </div>
      <div
        v-if="index == 0"
        class="form-group"
        :class="{ 'form-error': !object.koerier.required && object.$error }"
      >
        <label
          >Een tweede koerier als extra hulp?
          <vue-custom-tooltip
            multiline="true"
            size="is-large"
            position="is-right"
            label="Dit geldt voor alle objecten die met 1 man te sjouwen is of wanneer iemand meehelpt bij het ophaaladres en afleveradres. Zijn de objecten te zwaar, en heb je niemand om mee te helpen, kies dan voor een tweede koerier als extra hulp."
          >
            <i class="fas fa-info-circle tooltip_fas"></i>
          </vue-custom-tooltip>
        </label>
        <select v-model="object.koerier.$model">
          <option selected value="nee">Nee</option>
          <option value="ja">Ja</option>
        </select>
      </div>
    </div>

    <div class="row-3">
      <div
        class="form-group"
        :class="{
          'form-error': !object.oudspulmeenemen.required && object.$error
        }"
      >
        <label
          >Oude meubel meenemen?
          <vue-custom-tooltip
            multiline="true"
            size="is-large"
            position="is-right"
            label="Wij nemen je oude meubels mee en zorgen ervoor dat het
bij de juiste stort terechtkomt."
          >
            <i class="fas fa-info-circle tooltip_fas"></i>
          </vue-custom-tooltip>
        </label>
        <select v-model="object.oudspulmeenemen.$model">
          <option value="nee">Nee</option>
          <option value="ja">Ja</option>
        </select>
      </div>
      <div
        class="form-group"
        :class="{
          'form-error': !object.demontagemontage.required && object.$error
        }"
      >
        <label
          >Demontage / Montage?
          <vue-custom-tooltip
            multiline="true"
            size="is-large"
            position="is-right"
            label="Moeten de tafelpoten gedemonteerd en gemonteerd
worden? Kies dan voor ja."
          >
            <i class="fas fa-info-circle tooltip_fas"></i>
          </vue-custom-tooltip>
        </label>
        <select v-model="object.demontagemontage.$model">
          <option value="nee">Nee</option>
          <option value="ja">Ja</option>
        </select>
      </div>
      <div
        class="form-group"
        :class="{ 'form-error': !object.packing.required && object.$error }"
      >
        <label
          >Inpakken?
          <vue-custom-tooltip
            multiline="true"
            size="is-large"
            position="is-right"
            label="Meubels worden
met noppenfolie en stretchfolie professioneel ingepakt. Aangeraden bij kostbare meubels."
          >
            <i class="fas fa-info-circle tooltip_fas"></i>
          </vue-custom-tooltip>
        </label>
        <select v-model="object.packing.$model">
          <option value="nee">Nee</option>
          <option value="ja">Ja</option>
        </select>
      </div>
    </div>
    <div class="row-3">
      <div v-if="index == 0" class="form-group">
        <label
          >Is er een verhuislift nodig?
          <vue-custom-tooltip
            multiline="true"
            size="is-large"
            position="is-right"
            label="Kies voor een verhuislift vanaf de 3de verdieping
zonder lift en/of wanneer het niet in de lift past."
          >
            <i class="fas fa-info-circle tooltip_fas"></i>
          </vue-custom-tooltip>
        </label>
        <select v-model="verhuislift">
          <option selected value="nee"
            >Nee, er is geen verhuislift nodig.</option
          >
          <option value="ja">Ja, er is een verhuislift nodig.</option>
        </select>
      </div>
    </div>

    <div class="error" v-if="object.$error">
      Niet alle velden binnen dit voorwerp zijn goed ingevuld.
    </div>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import VueCustomTooltip from "@adamdehaven/vue-custom-tooltip";

export default {
  name: "Objects",
  components: {
    VueCustomTooltip
  },
  props: ["object", "index"],
  computed: {
    ...mapFields(["verhuislift"])
  },
  mounted() {
    if (this.verhuislift === "") {
      this.verhuislift = "nee";
    }
  },
  methods: {
    // changeObject() {
    //   if (this.object.gewicht.$model !== "0-34kg") {
    //     this.object.koerier.$model = "ja";
    //   }
    // }
  }
  // watch: {
  //   object(oldVal, newVal) {
  //     let re = new RegExp(/^[0-9]*([,.][0-9]{0,2})?$/);

  //     if (re.test(newVal.lengte)) {
  //       this.object.lengte = oldVal;
  //     }
  //   },
  // },
};
</script>

<style lang="scss" scoped>
.fas {
  font-size: 18px;
  margin-right: 8px;
  color: var(--orange);
}
.card {
  padding: 30px 40px;
  border: 1px solid var(--light-grey);
  margin-bottom: 10px;
  position: relative;
}

.row {
  display: grid;
  grid-template-columns: 5fr 2fr 2fr;
  grid-gap: 10px;
  margin-bottom: 24px;

  @media only screen and (max-width: 1200px) {
    grid-template-columns: 1fr !important;
  }
}

.row-3 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 10px;
  margin-bottom: 24px;

  @media only screen and (max-width: 1200px) {
    grid-template-columns: 1fr !important;
  }
}

.btn__close {
  position: absolute;
  top: 15px;
  right: 15px;
  font-size: 20px;
}

.btn__photo {
  margin-top: 27px;
  font-size: 14px;
  font-weight: 300;
}
.tooltip_fas {
  font-size: 15px;
  margin-right: 8px;
  color: var(--orange);
}
.vue-custom-tooltip {
  --vue-custom-tooltip-border-radius: 5px;
  float: right;
}
</style>
